//? PLUGINS //
import {
    Box,
    BoxProps,
    Button,
    ButtonProps,
    Grid,
    GridProps,
    useTheme,
} from "@mui/material";
import React from "react";

//? COMPONENTS //
import DatePicker, { DatePickerType } from "components/formsUI/DatePicker";
import SelectNationality, {
    SelectTypes,
} from "components/formsUI/Select/nationality";
import SelectCountry from "components/formsUI/Select/country";
import TextField, { TextfieldTypes } from "components/formsUI/TextField";

//? EXTRA //
import { useTranslation } from "react-i18next";
import countries from "resources/countries_en_nl.json";

//? STYLES //
import * as Styles from "pages/requests/stepsIndividual/step1/step1.styles";

import yup from "yup";
import i18next from "i18next";
import { useParams } from "react-router-dom";
import { FORM_VALIDATION } from "./step1";
import { useField, useFormikContext } from "formik";

//! ------------------------------------------------------------------------------------ //

interface Props {
    title: string;
    onBackClick: () => void;
    titlePath?: string;
}
interface CountriesType {
    id: number;
    name: { en: string; nl: string };
    nationality: { en: string; nl: string };
}

const Content = ({ title, onBackClick, titlePath }: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const locale = i18next.language === "en" ? "en" : "nl";
    const { applicationId, completionHash } = useParams()
    const [nationalityField] = useField("userNationality");

    const [disabled, setDisabled] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (titlePath && titlePath === 'requestAll.completeTitle') {
            setDisabled(true);
        }
    }, [setDisabled])

    // TODO : Add to global styles
    const gridContainerProps: GridProps = {
        container: true,
        spacing: 2,
        minHeight: 500,
    };
    const gridItemFullProps: GridProps = {
        item: true,
        xs: 12,
    };
    const gridItemHalfProps: GridProps = {
        item: true,
        xs: 6,
    };
    const gridItemNameProps: GridProps = {
        item: true,
        xs: 12,
        sm: 6,
        md: 6

    };

    const titleProps: BoxProps = {
        component: "h1",
        sx: Styles.titleCSS(theme),
    };
    const userFirstNameProps: TextfieldTypes = {
        name: "userFirstName",
        label: t("requestIndividual.step1.firstName"),
    };
    const userLastNameProps: TextfieldTypes = {
        name: "userLastName",
        label: t("requestIndividual.step1.lastName"),
    };
    const userBirthDayProps: DatePickerType = {
        name: "userBirthDay",
        label: t("requestIndividual.step1.birthDate"),
        // minDate: dayjs().subtract(68, 'years'),
        // maxDate: dayjs().subtract(16, 'years')
    };

    const userBirthPlaceProps: TextfieldTypes = {
        name: "userBirthPlace",
        label: t("requestIndividual.step1.birthPlace"),
    };
    const userNationalityProps: SelectTypes = {
        name: "userNationality",
        label: t("requestIndividual.step1.nationality"),
        options: countries,
    };

    const rnnProps: TextfieldTypes = {
        name: "userRRN",
        isRRN: nationalityField.value && (
            nationalityField.value == 'Belg' ||
            nationalityField.value == 'Belgisch' ||
            nationalityField.value == 'Belgian'
        ) ? true : false,
        label: t("requestIndividual.step1.rrn"),
    }

    const userCountryProps: SelectTypes = {
        name: "userAddressCountry",
        label: t("requestIndividual.step1.country"),
        options: countries,
    };

    const buttonProps = (buttonName: string): ButtonProps => {
        if (buttonName === "previous") {
            return {
                onClick: onBackClick,
                variant: "contained",
                sx: Styles.buttonCSS(theme, buttonName),
            };
        } else {
            return {
                type: "submit",
                variant: "contained",
                sx: Styles.buttonCSS(theme, buttonName),
            };
        }
    };

    return (
        <Box sx={Styles.containerCSS(theme)}>
            <Grid {...gridContainerProps}>
                {/* //* Title */}
                <Grid {...gridItemFullProps}>
                    <Box {...titleProps}>{title}</Box>
                </Grid>
                {/* //* First Name */}

                <Grid {...gridItemNameProps}>
                    <TextField {...userFirstNameProps} />
                </Grid>
                <Grid {...gridItemNameProps}>
                    <TextField {...userLastNameProps} />
                </Grid>
                <Grid {...gridItemHalfProps}>
                    <DatePicker {...userBirthDayProps} />
                </Grid>
                <Grid {...gridItemHalfProps}>
                    <TextField {...userBirthPlaceProps} />
                </Grid>
                <Grid {...gridItemHalfProps}>
                    <SelectNationality {...userNationalityProps} />
                </Grid>
                <Grid {...gridItemHalfProps}>
                    <TextField {...rnnProps} />
                </Grid>
                <Grid {...gridItemFullProps}>
                    <TextField
                        name="userEmail"
                        label={t("requestIndividual.step1.email")}
                        disabled={disabled}
                    />
                </Grid>
                <Grid {...gridItemFullProps}>
                    <TextField
                        name="userAddressStreet"
                        label={t("requestIndividual.step1.street")}
                    />
                </Grid>
                <Grid {...gridItemHalfProps}>
                    <TextField
                        name="userAddressHouseNumber"
                        label={t("requestIndividual.step1.number")}
                    />
                </Grid>
                <Grid {...gridItemHalfProps}>
                    <TextField
                        name="userAddressBox"
                        label={t("requestIndividual.step1.box")}
                        placeholder={t("requestIndividual.step1.optional")}
                    />
                </Grid>
                <Grid {...gridItemHalfProps}>
                    <TextField
                        name="userAddressZip"
                        label={t("requestIndividual.step1.zip")}
                    />
                </Grid>
                <Grid {...gridItemHalfProps}>
                    <TextField
                        name="userAddressCity"
                        label={t("requestIndividual.step1.city")}
                    />
                </Grid>
                <Grid {...gridItemFullProps}>
                    <SelectCountry {...userCountryProps} />
                </Grid>
            </Grid>

            <Box sx={Styles.buttonContainerCSS(theme)}>
                <Button {...buttonProps("next")}>{t("buttons.next")}</Button>
            </Box>

        </Box>
    );
};

export default Content;
